import { DNABox, Iffy, luxColors, util } from '@alucio/lux-ui';
import React, { useEffect } from 'react';
import { Platform, StyleSheet } from 'react-native';
import ScreenShareTracks from '../../ParticipantTracks/ShareScreen';
import ShareContent from '../../Virtual/ShareContent/ShareContent';
export var PresentationMode;
(function (PresentationMode) {
    PresentationMode["FULLSCREEN"] = "fullscreen";
    PresentationMode["NORMAL"] = "normal";
})(PresentationMode || (PresentationMode = {}));
const styles = StyleSheet.create({
    presentationWrapper: {
        marginVertical: 8,
        paddingHorizontal: 8,
    },
    presentationWrapperFullScreen: {
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        maxWidth: 'auto',
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        backgroundColor: luxColors.virtual.background,
    },
});
export function PresentationContainer(props) {
    const { isHostPresenting, presentation, screenShareParticipant, toggleShareScreen, background, isInitialState, mode, } = props;
    useEffect(() => {
        var _a;
        if (Platform.OS === 'web') {
            const style = (_a = (document.getElementById('app'))) === null || _a === void 0 ? void 0 : _a.style;
            mode === PresentationMode.FULLSCREEN ? style.display = 'none' : style.display = 'block';
        }
    }, [mode]);
    const presentationElement = (React.createElement(DNABox, { fill: true, style: util.mergeStyles(undefined, styles.presentationWrapper, [styles.presentationWrapperFullScreen, mode === PresentationMode.FULLSCREEN]) },
        React.createElement(Iffy, { is: isHostPresenting }, presentation),
        React.createElement(Iffy, { is: screenShareParticipant && !isHostPresenting },
            React.createElement(ScreenShareTracks, { participant: screenShareParticipant, onStopShare: toggleShareScreen })),
        React.createElement(Iffy, { is: !isHostPresenting && !screenShareParticipant },
            React.createElement(ShareContent, { background: background, text: isInitialState ? 'Welcome to the meeting!' : '', showWelcomeText: isInitialState }))));
    if (Platform.OS === 'web' && mode === PresentationMode.FULLSCREEN) {
        const { createPortal } = require('react-dom');
        return (createPortal(presentationElement, document.getElementsByTagName('body')[0]));
    }
    else {
        return (presentationElement);
    }
}
//# sourceMappingURL=DNAPresentationContainer.js.map